/* eslint-disable sort-imports */
/* eslint-disable camelcase */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable no-param-reassign */
import parseHTML from '../utils/parseHtml';

class SupportLobbyInstance {
  constructor(node) {
    this.selectorNode = node;

    this.selectors = {
      container: '.b-support-lobby__posts-body',
      filters: '.b-support-lobby__filters',
      search: '.b-support-lobby__filter-query-input',
      category: '.b-support-lobby__filter-category-select',
      pagination: '.c-paging-bar',
      article: '.b-support-lobby__post-item',
      articlePlaceholder: '.b-support-lobby__post-item--placeholder',
      paginationInfo: '.b-support-lobby__pagination-info',
      paginationPrev: '.b-support-lobby__pagination-nav-btn--prev',
      paginationNext: '.b-support-lobby__pagination-nav-btn--next',
      paginationPage: '.c-paging-bar__page',
      paginationLoadmore: '.b-support-lobby__loadmore',
      paginationLoadmoreBtn: '.b-support-lobby__loadmore-btn',
      paginationLoadmoreNoMore: '.b-support-lobby__loadmore-nomore',
      categoriesSlider: '.b-support-lobby__filter-slider',
      tagCategory: '.b-support-lobby__item-tag',
      categoryButtons: '.b-support-lobby__filter-slider-button',
      categoryButtonSelected:
        '.b-support-lobby__filter-slider-button--selected',
      title: '.b-support-lobby__title',
      externalCategories: '.b-featured-article__category',
    };

    this.classes = {
      categoriesSliderWrap: 'b-support-lobby__filter-slider-wrap',
      categoryButton: 'b-support-lobby__filter-slider-button',
      categoryButtonSelected: 'b-support-lobby__filter-slider-button--selected',
      paginationPageSelected: 'c-paging-bar__page--selected',
      paginationArrow: 'c-paging-bar__page--arrow',
      article: 'b-support-lobby__post-item',
      articlePlaceholder: 'b-support-lobby__post-item--placeholder',
      elementPlaceholder: 'b-support-lobby__placeholder',
      paginationLoadmoreBtnHidden: 'b-support-lobby__loadmore-btn--hidden',
      paginationLoadmoreNoMoreHidden:
        'b-support-lobby__loadmore-nomore--hidden',
      externalCategoryPointer: 'b-support-lobby__external-category--pointer',
    };

    if (!this.selectorNode) {
      return;
    }

    this.nodes = {
      container: this.selectorNode.querySelector(this.selectors.container),
      filters: this.selectorNode.querySelector(this.selectors.filters),
      search: this.selectorNode.querySelector(this.selectors.search),
      title: this.selectorNode.querySelector(this.selectors.title),
      paging: this.selectorNode.querySelector(this.selectors.pagination),
      category: this.selectorNode.querySelector(this.selectors.category),
      categoryButtons: [
        ...this.selectorNode.querySelectorAll(this.selectors.categoryButtons),
      ],
      externalCategories: document.body.querySelectorAll(
        this.selectors.externalCategories,
      ),
      pagingInfo: this.selectorNode.querySelector(
        this.selectors.paginationInfo,
      ),
      pagingLoadmore: this.selectorNode.querySelector(
        this.selectors.paginationLoadmore,
      ),
      pagingLoadmoreBtn: false,
      pagingLoadmoreNomore: false,
    };

    this.urlState = this.nodes.container.dataset.urlState === '1';

    this.bootstrap();
  }

  bootstrap() {
    this.initialState = this.getState();
    this.currentState = { ...this.initialState };

    this.pagingInit();
    this.pagingLoadmoreInit();
    this.categoryButtonsInit();
    this.searchInit();
    this.categoryInit();
    this.attachExternalCategories();
    this.historyInit();
    this.tagInit();
  }

  categoryButtonsInit() {
    if (!this.nodes.categoryButtons) {
      return;
    }

    const { categoryButtons } = this.nodes;

    categoryButtons.forEach(categoryButton => {
      categoryButton.addEventListener('click', event => {
        event.preventDefault();

        if (this.nodes.category) {
          this.nodes.category.value = categoryButton.dataset.value || '';
          this.nodes.category.dispatchEvent(new Event('change'));
        }
      });
    });
  }

  categoryInit() {
    if (!this.nodes.category) {
      return;
    }

    const { category } = this.nodes;

    category.addEventListener('change', event => {
      event.preventDefault();

      if (this.nodes.categoryButtons) {
        this.nodes.categoryButtons.forEach(categoryButtonNested =>
          categoryButtonNested.classList.remove(
            this.classes.categoryButtonSelected,
          ),);

        const activeButton = this.nodes.categoryButtons.find(
          categoryButton => categoryButton.dataset.value === category.value,
        );

        if (activeButton) {
          activeButton.classList.add(this.classes.categoryButtonSelected);
        }
      }

      this.chooseCategory(category, category.value);
    });
  }

  attachExternalCategories() {
    const { externalCategories } = this.nodes;

    externalCategories.forEach(category => {
      category.classList.add(this.classes.externalCategoryPointer);

      category.addEventListener('click', event => {
        event.preventDefault();

        const { slug, type } = category.dataset;

        const select = this.selectorNode.querySelector(
          `select[data-category-name="${type}"]`,
        );

        this.selectorNode.scrollIntoView();

        this.chooseCategory(select, slug);
      });
    });
  }

  tagInit() {
    const tagCategory = [
      ...this.selectorNode.querySelectorAll(this.selectors.tagCategory),
    ];

    tagCategory.forEach(tag => {
      const { slug, type } = tag.dataset;

      tag.addEventListener('click', () => {
        const select = this.selectorNode.querySelector(
          `select[data-category-name="${type}"]`,
        );

        this.chooseCategory(select, slug);
      });
    });
  }

  pagingLoadmoreInit() {
    if (!this.nodes.pagingLoadmore) {
      return;
    }

    this.nodes.pagingLoadmoreNomore = this.nodes.pagingLoadmore.querySelector(
      this.selectors.paginationLoadmoreNoMore,
    );
    this.nodes.pagingLoadmoreBtn = this.nodes.pagingLoadmore.querySelector(
      this.selectors.paginationLoadmoreBtn,
    );
    this.nodes.pagingLoadmoreBtn.addEventListener('click', event => {
      event.preventDefault();

      let { offset, postsPerPage } = this.nodes.container.dataset;

      offset = parseInt(offset, 10) || 0;
      postsPerPage = parseInt(postsPerPage, 10) || 0;

      this.fetchPosts({ loadmore: true, offset: offset + postsPerPage });
    });
  }

  pagingInit() {
    if (!this.nodes.paging) {
      return;
    }

    const paginationPrev = this.nodes.paging.querySelector(
      this.selectors.paginationPrev,
    );

    const paginationNext = this.nodes.paging.querySelector(
      this.selectors.paginationNext,
    );

    if (paginationPrev) {
      paginationPrev.addEventListener('click', event => {
        event.preventDefault();

        const { offset } = paginationPrev.dataset;

        this.nodes.filters.scrollIntoView({
          behavior: 'smooth',
        });

        this.fetchPosts({
          offset: offset || 0,
        });
      });
    }

    if (paginationNext) {
      paginationNext.addEventListener('click', event => {
        event.preventDefault();

        const { offset } = paginationNext.dataset;

        this.nodes.filters.scrollIntoView({
          behavior: 'smooth',
        });

        this.fetchPosts({
          offset: offset || 0,
        });
      });
    }

    const pages = this.nodes.paging.querySelectorAll(
      this.selectors.paginationPage,
    );

    pages.forEach(page => {
      page.addEventListener('click', event => {
        event.preventDefault();

        this.nodes.filters.scrollIntoView({
          behavior: 'smooth',
        });

        this.fetchPosts({ offset: page.dataset.offset || 0 });
      });
    });
  }

  searchInit() {
    if (!this.nodes.search) {
      return;
    }

    const { search } = this.nodes;

    if (search) {
      search.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
          event.preventDefault();
        }
      });

      search.addEventListener('keyup', event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          this.fetchPosts({ offset: 0 });
        }
      });
    }
  }

  chooseCategory(categorySelect, value) {
    if (!categorySelect) {
      return;
    }

    const { container } = this.nodes;
    const { urlState } = container.dataset;

    const data = this.getState();

    if (urlState !== '1') {
      this.fetchPosts({
        offset: 0,
        category: value,
        categorySelect: true,
      });
    } else {
      const activeCategory = categorySelect.querySelector(
        `option[value="${value}"]`,
      );

      if (activeCategory) {
        let { url } = activeCategory.dataset;

        container.dataset.baseUrl = url;

        url = new URL(url);

        if (typeof data.s !== 'undefined') {
          if (data.s) {
            url.searchParams.set('s', data.s || '');
          } else {
            url.searchParams.delete('s');
          }
        }

        history.pushState({}, null, url);

        this.fetchPosts({ offset: 0, url, categorySelect: true });
      }
    }

    if (value !== categorySelect.value) {
      categorySelect.value = value;
    }
  }

  historyInit() {
    const { container } = this.nodes;
    const { urlState } = container.dataset;

    if (urlState !== '1') {
      return;
    }

    addEventListener('popstate', event => {
      const data = event.state || this.initialState;

      if (this.nodes.search) {
        this.nodes.search.value = data.s || '';
      }

      this.fetchPosts({ ...data, popstate: true });
    });
  }

  getLocation(data, syncLocation = false) {
    const { container } = this.nodes;
    let { baseUrl: url } = container.dataset;

    const offset = parseInt(data.offset, 10) || 0;
    const postsPerPage = parseInt(data.postsPerPage, 10);

    if (this.urlState) {
      url = new URL(url);

      if (typeof data.s !== 'undefined') {
        if (data.s) {
          url.searchParams.set('s', data.s || '');
        } else {
          url.searchParams.delete('s');
        }
      }
    } else {
      url = new URL(url);

      url.searchParams.set('post_type', data.postType);
      url.searchParams.set('posts_per_page', postsPerPage);

      if (typeof data.offset !== 'undefined' && offset > 0) {
        url.searchParams.set('offset', offset);
      }

      if (typeof data.s !== 'undefined' && data.s) {
        url.searchParams.set('s', data.s);
      }

      if (typeof data.category !== 'undefined' && data.category) {
        url.searchParams.set('category', data.category);
      }
    }

    if (syncLocation) {
      const urlForHistory = new URL(url);

      if (typeof data.offset !== 'undefined' && offset > 0) {
        const paged = Math.ceil(offset / postsPerPage) + 1;

        urlForHistory.pathname += `page/${paged}/`;
      }

      history.pushState(data, null, urlForHistory);
    }

    return url;
  }

  getState() {
    const { container } = this.nodes;

    const { postType } = container.dataset;
    let { postsPerPage, offset, total } = container.dataset;

    total = parseInt(total, 10) || 0;
    offset = parseInt(offset, 10) || 0;
    postsPerPage = parseInt(postsPerPage, 10) || 0;

    let s = ''; // eslint-disable-line id-length

    if (this.nodes.search) {
      const { search } = this.nodes;

      s = search ? search.value : '';
    }

    return { postsPerPage, postType, offset, total, s }; // eslint-disable-line id-length
  }

  placeholdNode(element) {
    element.classList.add(this.classes.articlePlaceholder);

    const selectors = (
      this.nodes.container.dataset.placeholderSelectors || ''
    ).split(',');

    selectors.forEach(selector => {
      element
        .querySelectorAll(selector)
        .forEach(node => node.classList.add(this.classes.elementPlaceholder));
    });
  }

  // eslint-disable-next-line class-methods-use-this
  // eslint-disable-next-line sonarjs/cognitive-complexity
  fetchPosts(settings = {}) {
    const { container } = this.nodes;

    if (typeof settings.offset !== 'undefined') {
      container.dataset.offset = parseInt(settings.offset, 10);
    }

    const state = this.getState(); // eslint-disable-line id-length

    const { postsPerPage, offset, total } = state;

    if (!settings.loadmore) {
      const articles = container.querySelectorAll(this.selectors.article);

      articles.forEach(article => this.placeholdNode(article));
    } else {
      const articleFirst = container.querySelector(this.selectors.article);

      if (articleFirst) {
        let totalForPlaceholder = postsPerPage;

        if (offset + postsPerPage > total) {
          totalForPlaceholder = total - offset;
        }

        for (let i = 0; i < totalForPlaceholder; i++) {
          const newNode = articleFirst.cloneNode(true);

          this.placeholdNode(newNode);

          container.appendChild(newNode);
        }
      }
    }

    const url =
      settings.url ||
      this.getLocation(
        state,
        !settings.popstate && !settings.categorySelect && this.urlState,
      );

    const urlFinal = new URL(url);

    if (settings.category) {
      urlFinal.searchParams.append('category_name', settings.category);
    }
    urlFinal.searchParams.append('offset', container.dataset.offset);
    urlFinal.searchParams.append('support_lobby_partial_json', true);

    fetch(urlFinal, {
      method: 'GET',
    })
      .then(result => result.json())
      .then(responseData => this.loadResponse(responseData, settings));
  }

  loadResponse(responseData, settings) {
    const { container } = this.nodes;

    if (!settings.loadmore) {
      container.innerHTML = responseData.content;
    } else {
      [ ...parseHTML(responseData.content) ].forEach(item => {
        container.append(item);
      });
    }

    const articles = container.querySelectorAll(
      this.selectors.articlePlaceholder,
    );

    articles.forEach(article => article.remove());

    this.tagInit();

    if (responseData.paginationNumbers && this.nodes.paging) {
      this.nodes.paging.innerHTML = responseData.paginationNumbers;
      setTimeout(() => this.pagingInit(), 0);
    }

    if (responseData.paginationInfo && this.nodes.pagingInfo) {
      this.nodes.pagingInfo.innerHTML = responseData.paginationInfo;
    }

    if (this.nodes.pagingLoadmoreBtn) {
      this.nodes.pagingLoadmoreBtn.classList[
        !responseData.noMore ? 'remove' : 'add'
      ](this.classes.paginationLoadmoreBtnHidden);
    }

    if (this.nodes.pagingLoadmoreNomore) {
      this.nodes.pagingLoadmoreNomore.classList[
        responseData.noMore ? 'remove' : 'add'
      ](this.classes.paginationLoadmoreNoMoreHidden);
    }

    container.dataset.offset = parseInt(responseData.offset, 10);
    container.dataset.postsPerPage = parseInt(responseData.postsPerPage, 10);

    if (!settings.popstate && responseData.title) {
      document.title = responseData.title;
    }
  }
}
export default class SupportLobby {
  constructor() {
    this.selector = '.b-support-lobby';
  }

  bootstrap() {
    const nodes = document.querySelectorAll(this.selector);

    nodes.forEach(node => new SupportLobbyInstance(node));
  }
}
